import styled from "styled-components";

export const Heading = styled.h1`
    font-size: 2rem;
    color: #fff;
    text-align: center;
    margin-bottom: 1rem;
`;

export const Description = styled.p`
    font-size: 1.2rem;
    color: #fff;
    text-align: center;
    padding: 0 1rem;

    &.reveal{
        font-size: 1.8rem;
    }
`;